import { createSvgIcon } from 'shared/icons/IconUtils';

export const SizesIcon = createSvgIcon(
  'SizesIcon',
  <>
    <path
      d="M8 17.878a.97.97 0 0 0 .713-.288.968.968 0 0 0 .287-.712.968.968 0 0 0-.287-.713.967.967 0 0 0-.713-.287.967.967 0 0 0-.713.287.968.968 0 0 0-.287.713c0 .283.096.52.287.712.192.192.43.288.713.288Zm8 0c.283 0 .52-.096.712-.288a.968.968 0 0 0 .288-.712.968.968 0 0 0-.288-.713.968.968 0 0 0-.712-.287.968.968 0 0 0-.713.287.968.968 0 0 0-.287.713c0 .283.096.52.287.712.192.192.43.288.713.288Zm-11-2.9 1.65-4.8c.083-.233.22-.425.412-.575a1.01 1.01 0 0 1 .638-.225h8.6c.233 0 .446.075.637.225.192.15.33.342.413.575l1.65 4.8v6.6a.779.779 0 0 1-.225.575.779.779 0 0 1-.575.225h-.4a.779.779 0 0 1-.575-.225.779.779 0 0 1-.225-.575v-1.2H7v1.2a.779.779 0 0 1-.225.575.779.779 0 0 1-.575.225h-.4a.779.779 0 0 1-.575-.225.779.779 0 0 1-.225-.575v-6.6Zm2.65-1.6h8.7l-.7-2h-7.3l-.7 2Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
    <path
      d="m4.293 2.67 1.414 1.415-1.293 1.293h15.172l-1.293-1.293 1.414-1.414 3.707 3.707-3.707 3.707-1.414-1.414 1.293-1.293H4.414L5.707 8.67l-1.414 1.414L.586 6.378 4.293 2.67Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </>,
);
